<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader>
      <TextHeading variant="subtitle" color="secondary">Shareholder Information</TextHeading>
      <TextHeading variant="xl">Shareholder Communication</TextHeading>
    </PageHeader>
    <PageGrid sidebar>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
      </PageSide>
      <PageMain>
        <TextProse>You can now choose how you’d like to receive your shareholding documents – online or by post.
          <br>
          <br>Going forward we are now using this website as our main way of communicating with shareholders, thanks to recent changes in legislation. This means that you’ll be able access all your shareholder documents quickly and easily online. Not only is this the fastest means of communication but it’s also environmentally friendly, something we can all feel good about.
          <br>
          <br>Find out how it works and have a look at some of the great
          <router-link to="/">benefits</router-link>&nbsp;of signing up for online communication. You can also read the answers to some of the most frequently asked questions.
        </TextProse>
        <ButtonsWithText/>
        <TextAccordion :items="accordionItems"/>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import ButtonsWithText from '../components/ButtonsWithText.vue'
import TextAccordion from '../components/TextAccordion.vue'
import TextProse from '../elements/TextProse.vue'
import PageMain from '../elements/PageMain.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'ShareholderCommunication',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    PageMain,
    TextProse,
    TextAccordion,
    ButtonsWithText,
    TheFooter
  },
  data() {
    return {
      accordionItems: [
        {
          category: "FAQ's",
          title: 'Why has this change happend?',
          value:
            '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo.</p><p>Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.</p>',
          linktext: '',
          link: ''
        },
        {
          category: "FAQ's",
          title:
            'How do I manage my shareholding online and receive email notifications?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: "FAQ's",
          title: 'A third Question?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: "FAQ's",
          title: 'Why has this change happend?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: "FAQ's",
          title:
            'How do I manage my shareholding online and receive email notifications?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: "FAQ's",
          title: 'A third Question?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'How it works and benefits',
          title: 'What should I do if my email address changes?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'How it works and benefits',
          title:
            'What services are available online to manage my shareholding?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Category Three',
          title: 'Extra long text to test how the accordion wraps',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        }
      ]
    }
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
</style>